<template>
  <div class="recordList"> 
        <ul class="list" v-if='detailList.length'>
            <li class='item-li' v-for='item in detailList' :key='item.photoId'>
            <p class="rows"><label class="label">会员帐号：</label><span class="span">{{item.vipId}}</span></p>
            <p class="rows"><label class="label">兑换金额：</label><span class="span">{{item.money}} 元</span></p>
            <p class="rows"><label class="label">积分状态：</label>
                <span class="span" v-if='item.stat=="0"' style='color:#2DB7F5'>审核中</span>
                <span class="span" v-if='item.stat=="1"' style='color:grey'>未通过</span>
                <span class="span" v-if='item.stat=="2"' style='color:#33CC00'>已通过</span>
            </p>
            <p class="rows" v-if='item.note'><label class="label">备注：</label>
                <span class="span" v-if='item.stat=="1"'>{{item.note}}</span>
            </p>
            
            </li>
        </ul>
        <div class="nodata" v-else>
            暂无数据
        </div>
  </div>
</template>
<script>
export default {
  name: "recordList",
  props:{
    list: {
      type: Array,
      default:() =>{
        return []
      }
    },
  },
  computed:{
      detailList:function(){
          return this.list;
      }
  }
};
</script>
<style lang="scss" scoped>
.list{
    padding:20px 0;
    // height:100%;
    // overflow-y: auto;
    & .item-li{
        margin:10px 0;
        padding: 10px;
        background: #efefef;
        border-radius: 5px;
        & .rows{
            line-height: 28px;
            color:#333;
            font-size:14px;
        }
    }
    
    & .item-li:first-child{
        margin-top:0;
    }
    & .item-li:last-child{
        margin-bottom:0;
    }
}
.nodata{
    margin-top:60px;
    text-align: center;
    color:#333;
}
</style>
